const checkIfUserHasAccess = (accessStringToCheck) => {
  const storedUser = localStorage.getItem("currentUser");

  // 1. Check if the item actually exists in localStorage
  if (!storedUser) {
    return false; // Or true, depending on your default "logged out" security
  }

  try {
    const userLoginDetailsArray = JSON.parse(storedUser);

    // 2. Safely check if it's an array and has the useraccess property
    const userAccessString = userLoginDetailsArray?.[0]?.useraccess;

    if (!userAccessString) return true; // Show by default if no access string found

    // 3. Check for the access string
    if (userAccessString.indexOf(accessStringToCheck) !== -1) {
      console.log("Access restricted for:", accessStringToCheck);
      return false;
    } else {
      return true;
    }
  } catch (error) {
    console.error("Error parsing user data:", error);
    return false;
  }
};

export default checkIfUserHasAccess;
